import React from 'react';
import { PaymentLogos } from './PaymentLogos';
import { trackInitiateCheckout } from '../lib/pixel';
export function PaymentSection() {
  return <section className="w-full bg-zinc-950/30" data-id="element-105">
      {/* Top gold separator */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/40 to-transparent" data-id="element-106" />

      <div className="max-w-2xl mx-auto py-12 px-4" data-id="element-107">
        <div className="text-center space-y-5" data-id="element-108">
          {/* CTA Button */}
          <a href="https://templeofpages.com/cart/48775105052915:1?locale=es" target="_blank" rel="noopener noreferrer" onClick={() => trackInitiateCheckout()} className="block w-full text-center bg-[#B8860B] text-black font-['Playfair_Display'] font-bold text-xl md:text-2xl lg:text-3xl py-6 hover:bg-[#C5A014] transition-all duration-300 shadow-lg hover:shadow-[0_0_40px_rgba(184,134,11,0.3)] hover:scale-[1.02] no-underline" aria-label="Comprar ahora por 10 dólares" data-id="element-109">
            QUIERO LEER EL LIBRO AHORA — 9.99 USD
          </a>

          {/* Payment Methods */}
          <PaymentLogos data-id="element-110" />

          {/* Urgency */}
          <p className="font-['Crimson_Text'] text-sm md:text-base text-zinc-400" data-id="element-111">
            ⏳ Precio disponible por tiempo limitado
          </p>

          {/* Trust Badges */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 pt-2" data-id="element-112">
            <div className="flex items-center gap-2 text-zinc-400" data-id="element-113">
              <span className="text-lg" data-id="element-114">✅</span>
              <span className="font-['Crimson_Text'] text-sm md:text-base" data-id="element-115">
                Descarga inmediata
              </span>
            </div>
            <div className="flex items-center gap-2 text-zinc-400" data-id="element-116">
              <span className="text-lg" data-id="element-117">📱</span>
              <span className="font-['Crimson_Text'] text-sm md:text-base" data-id="element-118">
                Compatible con cualquier dispositivo
              </span>
            </div>
            <div className="flex items-center gap-2 text-zinc-400" data-id="element-119">
              <span className="text-lg" data-id="element-120">🔒</span>
              <span className="font-['Crimson_Text'] text-sm md:text-base" data-id="element-121">
                Pago 100% seguro
              </span>
            </div>
          </div>

          {/* Format */}
          <p className="font-['Crimson_Text'] text-sm text-zinc-500 pt-2" data-id="element-122">
            Formato: PDF · Acceso inmediato tras la compra
          </p>
        </div>
      </div>

      {/* Bottom gold separator */}
      <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-[#C5A014]/40 to-transparent" data-id="element-123" />
    </section>;
}